/**
 * Firebase Configuration for EFAIPM
 * Uses the unified executive-force-ai-453011 project for SSO across all apps
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

// Firebase configuration - unified SSO for all Executive Force AI apps
const firebaseConfig = {
  apiKey: "AIzaSyDzSVcepxdliuW-nM026lRmopvg324Q-XY",
  authDomain: "executive-force-ai-453011.firebaseapp.com",
  projectId: "executive-force-ai-453011",
  storageBucket: "executive-force-ai-453011.firebasestorage.app",
  messagingSenderId: "327026071945",
  appId: "1:327026071945:web:17e73a735d4ac4cc25a958",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth
export const auth = getAuth(app);

// Google Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Sign in with Google
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    const idToken = await user.getIdToken();

    return {
      user,
      idToken,
      email: user.email,
      displayName: user.displayName,
      uid: user.uid,
      photoURL: user.photoURL
    };
  } catch (error) {
    console.error('Google sign-in error:', error);
    throw error;
  }
};

export default app;
